import { Form, Input, InputNumber, Select, Tooltip, Empty } from "antd";
import { memo } from "react";
import "moment/locale/ja";

import NewSvg from "../../../../../assets/icons/new.svg";
import SquarePurple from "../../../../../assets/icons/squarer-purple.svg";
import VectorMinus from "../../../../../assets/icons/vector-minus.svg";

import { CR001AmountRelateHandler } from "../handler/HandlerImpl";
import REGEX from "../../../../../common/constants/REGEX";
import MESSAGE from "../../../../../common/constants/MESSAGE";
import { onBlurTrimFormItem } from "../../../../../common/helpers/typeInput";
import helpers from "../../../../../common/helpers/common";
import COMMON from "../../../../../common/constants/COMMON";
import UploadEvidenceComponent from "../../../../../common/components/common-form-item-cm/upload-evidence";
import DocumentIconSvg from "../../../../../assets/icons/document-icon.svg";
import UploadFileCRComponent from "../../../../../common/components/upload-cr";

const { Item } = Form;

interface props {
  handler: CR001AmountRelateHandler;
}

const MESSAGE_REQUIRED = "";
const MAX_LENGTH_TEXT = 30;
const MIN_INPUT_NUMBER = 0;
const REQUIRED_INPUT = false;

const Labor = ({ handler }: props) => {
  return (
    <div className="cr001-cost-registration">
      <div className="cr001-cost-registration-title bg-title-row padding-tb-15 border-bottom">
        <img src={NewSvg} alt="" />
        <span className="text-bold-14">労務費登録</span>
      </div>
      <div className="cr003-table-wrapper">
        <table className="cr003-table cr003-table-5cols">
          <thead>
            <tr>
              <th>担当者</th>
              <th>見積金額（円）</th>
              <th>原価金額（円）</th>
              <th>予算金額（円）</th>
              <th>ファイル</th>
            </tr>
          </thead>
          <tbody>
            {handler.isEdit && (
              <tr className="cr003-add-row">
                <td colSpan={5} onClick={handler.handleAddLaborCost} style={{ borderBottom: '1px solid #d9d9d9' }}>
                  <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                    <img alt="" src={SquarePurple} />
                    <span className="text-bold-14" style={{ marginLeft: '10px', color: '#605bff', fontWeight: 700 }}>項目追加</span>
                  </div>
                </td>
              </tr>
            )}
            {handler.laborCostList?.map((laborCost: any) => {
              return (
                <tr
                  className="cr001-icon-rotate"
                  key={`laborCost${laborCost.key}`}
                >
                  <td>
                    {handler.isEdit ? (
                      <div className="cr001-cr-item-bonus">
                        <img
                          alt=""
                          src={VectorMinus}
                          onClick={() => handler.handleDeleteLaborCost(laborCost.key)}
                          className="cr001-margin-icon"
                        />
                        <Item
                          name={[`laborCost${laborCost.key}`, "managerId"]}
                          style={{ width: "100%", paddingLeft: 14, maxWidth: 180 }}
                          rules={[
                            () => ({
                              validator(_, value) {
                                if (value && value !== "") {
                                  // CHECK INPUT VIETNAMESE
                                  if (!REGEX.NOT_VIETNAM.test(value)) {
                                    return Promise.reject(
                                      new Error(MESSAGE.MESSAGE_INPUT_INVALID)
                                    );
                                  }
                                  if (value?.length > MAX_LENGTH_TEXT) {
                                    return Promise.reject(new Error(""));
                                  }
                                  return Promise.resolve();
                                }
                                return Promise.resolve();
                              },
                            }),
                          ]}
                        >
                          <Select
                            size="large"
                            listHeight={210}
                            showSearch
                            filterOption={() => true}
                            onDropdownVisibleChange={(open) => {
                              if (open) handler.handleGetListMember();
                            }}
                            onSearch={handler.handleSearchOption}
                            onPopupScroll={handler.handleScrollMember}
                            getPopupContainer={(trigger: any) => trigger.parentNode}
                            notFoundContent={
                              <Empty
                                image={Empty.PRESENTED_IMAGE_SIMPLE}
                                description="該当なデータはありません"
                                style={{ color: "#999da0" }}
                              />
                            }
                            className="cr003-select-member"
                          >
                            {handler.members?.map((select) => {
                              return (
                                <Select.Option
                                  style={{ alignItems: "center" }}
                                  key={select?.id}
                                  value={select?.id}
                                >
                                  <div
                                    style={{
                                      fontSize: 14,
                                      fontWeight: 600,
                                      color: "#121212",
                                    }}
                                  >
                                    {select?.fullName || select?.username}
                                  </div>
                                  <div
                                    style={{
                                      fontSize: 12,
                                      fontWeight: 400,
                                      color: "#666",
                                    }}
                                  >
                                    {select?.emailAddress}
                                  </div>
                                </Select.Option>
                              );
                            })}
                          </Select>
                        </Item>
                      </div>
                    ) : (
                      <Tooltip
                        title={
                          handler.listTooltip?.includes(`tooltip${laborCost.key}`)
                            ? laborCost?.manager?.fullName ||
                            laborCost?.manager?.username
                            : ""
                        }
                        getPopupContainer={(trigger: any) => trigger.parentNode}
                        overlayInnerStyle={{ color: "#fff", margin: "0 -4%" }}
                      >
                        <span
                          className="cr-text-long-tooltip text-tooltip"
                          id={`tooltip${laborCost.key}`}
                        >
                          {laborCost?.manager?.fullName ||
                            laborCost?.manager?.username}
                        </span>
                      </Tooltip>
                    )}
                  </td>
                  <td className="color-gray">
                    {handler.isEdit ? (
                      <Item
                        rules={[
                          {
                            required: REQUIRED_INPUT,
                            message: MESSAGE_REQUIRED,
                          },
                        ]}
                        name={[`laborCost${laborCost.key}`, "estimateMoney"]}
                      >
                        <InputNumber
                          controls={false}
                          maxLength={COMMON.MAX_INPUT_NUMBER}
                          max={COMMON.MAX_NUMBER_VALUE}
                          min={MIN_INPUT_NUMBER}
                          className="input-cr001 input-width-40"
                          formatter={(value) =>
                            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                          }
                          parser={(value: any) => value.replace(/\$\s?|(,*)/g, "")}
                        />
                      </Item>
                    ) : (
                      handler.checkFormatValue(laborCost?.estimateMoney, false, true)
                    )}
                  </td>
                  <td className="color-gray">
                    {handler.isEdit ? (
                      <Item
                        rules={[
                          {
                            required: REQUIRED_INPUT,
                            message: MESSAGE_REQUIRED,
                          },
                        ]}
                        name={[`laborCost${laborCost.key}`, "costMoney"]}
                      >
                        <InputNumber
                          controls={false}
                          maxLength={COMMON.MAX_INPUT_NUMBER}
                          max={COMMON.MAX_NUMBER_VALUE}
                          min={MIN_INPUT_NUMBER}
                          className="input-cr001 input-width-40"
                          formatter={(value) =>
                            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                          }
                          parser={(value: any) => value.replace(/\$\s?|(,*)/g, "")}
                        />
                      </Item>
                    ) : (
                      handler.checkFormatValue(laborCost?.costMoney, false, true)
                    )}
                  </td>
                  <td className="color-gray">
                    <div className="cr003-item-labor-cost-percent">
                      {handler.isEdit ? (
                        <>
                          <Item
                            rules={[
                              {
                                required: REQUIRED_INPUT,
                                message: MESSAGE_REQUIRED,
                              },
                            ]}
                            name={[`laborCost${laborCost.key}`, "budgetMoney"]}
                          >
                            <InputNumber
                              controls={false}
                              maxLength={COMMON.MAX_INPUT_NUMBER}
                              max={COMMON.MAX_NUMBER_VALUE}
                              min={MIN_INPUT_NUMBER}
                              className="input-cr001 input-width-40"
                              formatter={(value) =>
                                `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                              }
                              parser={(value: any) => value.replace(/\$\s?|(,*)/g, "")}
                            />
                          </Item>
                          {handler.checkFormatValue(
                            laborCost?.budgetMoneyPercent,
                            true,
                            true
                          )}
                        </>
                      ) : (
                        handler.checkFormatValue(laborCost?.budgetMoney, false, true) +
                        " " +
                        handler.checkFormatValue(
                          laborCost?.budgetMoneyPercent,
                          true,
                          true
                        )
                      )}
                    </div>
                  </td>
                  <td className="color-gray">
                    {handler.isEdit ? (
                      <UploadFileCRComponent
                        nameForm={[`laborCost${laborCost.key}`, "documentLaborCost"]}
                        fileNameDefault={laborCost.document}
                        form={handler.formAmount}
                        afterClear={() =>
                          handler.afterClear(
                            [`laborCost${laborCost.key}`, "documentLaborCost"],
                            handler.laborCostList,
                            "laborCost"
                          )
                        }
                      />
                    ) : laborCost?.document?.length != 0 ? (
                      <div
                        className="button-style"
                        onClick={() => {
                          handler.handleViewFile(laborCost, "labor");
                        }}
                      >
                        <img src={DocumentIconSvg} alt="" />
                      </div>
                    ) : null}
                  </td>
                </tr>
              );
            })}
          </tbody>
          <tfoot>
            <tr>
              <td className="color-gray" style={{ fontWeight: 400, color: '#666666' }}>合計金額</td>
              <td className="color-gray" style={{ fontWeight: 700, color: '#666666' }}>
                {handler.checkFormatValue(
                  handler.totalLaborList?.estimateMoney,
                  false,
                  true
                )}
              </td>
              <td className="color-gray" style={{ fontWeight: 700, color: '#666666' }}>
                {handler.checkFormatValue(
                  handler.totalLaborList?.costMoney,
                  false,
                  true
                )}
              </td>
              <td className="color-gray" style={{ fontWeight: 700, color: '#666666' }}>
                {handler.checkFormatValue(
                  handler.totalLaborList?.budgetMoney,
                  false,
                  true
                )}{" "}
                {handler.checkFormatValue(
                  handler.totalLaborList?.budgetMoneyPercent,
                  true,
                  true
                )}
              </td>
              <td></td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
};

export default memo(Labor);
